module.exports = __webpack_public_path__ + "static/media/hongdanshanadj.d4559e48.webp";